import { AnalyticsConfig } from './analytics.types';

export const LUMANA_MIXPANEL_PROJECT_KEY = '8504d05771fc3a17607cfc055e502419';

export function createBrowserAnalyticsConfig(environmentName: string): AnalyticsConfig {
  return {
    enabled: !environmentName.toLowerCase().startsWith('local'),
    projectKey: LUMANA_MIXPANEL_PROJECT_KEY,
    initialContext: {
      _env: environmentName,
      _origin: 'web',
      _source: 'web',
    },
  };
}
